module.exports = __webpack_public_path__ + "static/img/CloudWarehouse.5e74091.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/CloudWarehouse.png
// module id = iLbA
// module chunks = 2